export default __webpack_public_path__ + "static/meeting-room-d1749e7aedf29572351f7ff554666158.jpg";